import { useState } from 'react';
import { useAuth } from './AuthContext';

export function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch (e: unknown) {
      const msg = (e as { message?: string })?.message ?? String(e);
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: 24 }}>
      <form onSubmit={onSubmit} style={{
        width: '100%', maxWidth: 360, background: 'white', border: '1px solid var(--border)',
        borderRadius: 12, padding: 28,
      }}>
        <h1 style={{ margin: '0 0 6px', fontSize: '1.4rem', fontWeight: 700 }}>Super</h1>
        <p style={{ margin: '0 0 22px', color: 'var(--muted)', fontSize: 13 }}>
          Operator sign-in. Admins only.
        </p>
        <label style={{ display: 'block', fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
          required
          autoComplete="email"
          style={{ width: '100%', padding: '10px 12px', marginTop: 4, marginBottom: 14, border: '1px solid var(--border)', borderRadius: 6, fontSize: 14 }}
        />
        <label style={{ display: 'block', fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          style={{ width: '100%', padding: '10px 12px', marginTop: 4, marginBottom: 16, border: '1px solid var(--border)', borderRadius: 6, fontSize: 14 }}
        />
        {err && (
          <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: '8px 12px', borderRadius: 6, fontSize: 13, marginBottom: 14 }}>
            {err}
          </div>
        )}
        <button
          type="submit"
          disabled={busy || !email || !password}
          style={{ width: '100%', padding: '11px 14px', background: 'var(--green)', color: 'var(--ink-on-green)', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 600, cursor: 'pointer', opacity: busy ? 0.6 : 1 }}
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
